import { withStyles } from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import appConstants from '../../../appConstants';
import Events from '../../../utilities/EventEmitter';
import { inject } from 'mobx-react';
import ToolTip from '../../common/StyledToolTip';
import { cityRouteHoldProCount } from '../../modules/IBPlanning/RoutesView/utils';

const styles = (theme) => ({
  publishDialog: {
    padding: '18px 24px',
    boxSizing: 'border-box',
    borderRadius: '2px',
    backgroundColor: theme.ModalBGColor,
    boxShadow: '2px 2px 4px black'
  },
  publishDialogTitle: {
    fontSize: 14,
    fontWeight: '600',
    lineHeight: '20px',
    color: theme.HeaderSelectedText,
    padding: 0
  },
  publishDialogContent: {
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    overflow: 'hidden',
    padding: '16px 0px'
  },
  dialogAction: {
    justifyContent: 'space-between',
    margin: 0
  },
  button: {
    fontSize: 14,
    textTransform: 'none',
    borderRadius: '2px',
    margin: 0
  },
  buttonWidth: {
    width: '47%'
  },
  buttonConfirm: {
    width: '100%'
  },
  buttonContainerDisabled: {
    cursor: 'not-allowed',
    width: '47%'
  },
  publishCloseIcon: {
    padding: 0,
    float: 'right',
    color: theme.HeaderDefaultTextColor,
    '&:hover': {
      backgroundColor: theme.ModalBGColor,
      color: theme.HeaderSelectedText
    }
  },
  boldFont: {
    fontWeight: 600,
    paddingBottom: 8
  },
  boldHoldProFont: {
    fontWeight: 600,
    paddingBottom: 8,
    cursor: 'pointer',
    textDecoration: 'underline',
    paddingLeft: 4
  },
  warningInfo: {
    paddingTop: 16,
    display: 'none'
  },
  warning: {
    color: theme.ErrorMessageColor
  },
  holdProCountMessage: {
    color: theme.ErrorMessageColor,
    paddingTop: 8
  }
});
const HOLD_PRO_FILTERS = ['Hold Pro', 'Hold Pro(RM)', 'City'];

const PublishDialog = (props) => {
  const { classes, show, onClose, publish, configJSON, IBPlanningStore } = props;
  const { enableHoldPros, enableRoutePublishWithHoldPros } = configJSON;
  const { routesList, shipmentsList } = IBPlanningStore;
  const UNRTDRoute = routesList.find((route) => route.routeName === appConstants.UNRTD_ROUTENAME);
  const holdProCount = cityRouteHoldProCount({enableHoldPros, routesList, shipmentsList});
  const disablePublish = !enableRoutePublishWithHoldPros && holdProCount;
  const handleHoldProClick = () => {
    IBPlanningStore.updateShipmentAutoSelectedFilter(HOLD_PRO_FILTERS);
    if (window.location.pathname !== appConstants.NAV_URLS.IBPLANNING_SHIPMENTS) {
      Events.emit('RedirectToPage', null, appConstants.NAV_URLS.IBPLANNING_SHIPMENTS);
    }
    onClose();
  };

  return (
          <Dialog
        open={show}
        onClose={onClose}
        aria-labelledby="publish-dialog"
        classes={{ paper: classes.publishDialog }}>
        <DialogTitle
          disableTypography={true}
          classes={{ root: classes.publishDialogTitle }}
          id="publish-dialog">
          Publish To Dock
          <IconButton
            aria-label="Close"
            classes={{ root: classes.publishCloseIcon }}
            onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent classes={{ root: classes.publishDialogContent }}>
          <div className={classes.boldFont}>Are you sure you want to send the plan to dock?</div>
          {UNRTDRoute?.prosCount ? (
            <div>
              UNRTD Shipments: <span className={classes.boldFont}>{UNRTDRoute.prosCount}</span>
            </div>
          ) : null}
          {holdProCount ? (
            <div className={classes.holdProCountMessage}>
              Hold Pro(s) in city routes:
              <ToolTip title="Click to view hold pro(s) in city routes">
                <span className={classes.boldHoldProFont} onClick={handleHoldProClick}>
                  {holdProCount}
                </span>
              </ToolTip>
            </div>
          ) : null}
          <div className={classes.warningInfo}>
            <span className={classes.warning}>Note: </span> Changes after this will be auto-saved.
          </div>
        </DialogContent>
        <DialogActions classes={{ root: classes.dialogAction }}>
        <Button
          variant="outlined"
          color="primary"
          size="medium"
          className={`${classes.button} ${classes.buttonWidth}`}
          data-dd-action-name={"publish-route-cancel"}
          onClick={onClose}>
          Cancel
        </Button>
        <ToolTip
          title={
            disablePublish ? 'City Route(s) with Hold Pro(s) can not be published' : ''
          }>
          <span className={holdProCount ? classes.buttonContainerDisabled : classes.buttonWidth}>
            <Button
              variant="contained"
              color="primary"
              size="medium"
              disabled={disablePublish}
              className={`${classes.button} ${classes.buttonConfirm}`}
              data-dd-action-name={"publish-route-confirm"}
              onClick={publish}>
              Confirm
            </Button>
          </span>
        </ToolTip>
      </DialogActions>
    </Dialog>
  );
};

export default inject('IBPlanningStore')(withStyles(styles)(PublishDialog));
